module.exports = __webpack_public_path__ + "img/userInfo.b8b59751.png";